import { Component, computed, DefineComponent, reactive, Ref, ref } from 'vue'

import {
  Call,
  Campaign,
  CampaignListRecord,
  Organization,
  User,
} from '@letsdial/api'
export interface Tab {
  name: string
  component?: RawExtensionComponent
  iframe?: string
  filter?: (ctx: {
    user?: User
    call?: Call
    campaign?: Campaign
    organization?: Organization
    record?: CampaignListRecord
  }) => boolean
}

export interface MenuItem {
  icon: string
  label: string
  path: string
  permission?: {
    subject: string
    action: string
  }
}

declare type Lazy<T> = () => Promise<T>
export declare type ExtensionComponent = Component | DefineComponent
declare type RawExtensionComponent =
  | ExtensionComponent
  | Lazy<ExtensionComponent>

export interface LetsDialManagerType {
  registerExtension: (pluginName: string, config: ExtensionConfig) => void
  idleView: { addTab: (tab: Tab) => void }
  leadView: { addTab: (tab: Tab) => void; disableWrapOnCallEnd: () => void }
  inboundView: { addTab: (tab: Tab) => void }
  menuItems: { addMenu: (menu: MenuItem) => void }
}

export const registeredPlugins = reactive<{ [name: string]: ExtensionConfig }>(
  {},
)

export const idleTabs: Ref<Array<Tab>> = ref([])
export const leadTabs: Ref<Array<Tab>> = ref([])
export const inboundTabs: Ref<Array<Tab>> = ref([])
export const permissions = computed(() => {
  const items: { subject: string; action: string }[] = []
  for (const [, config] of Object.entries(registeredPlugins)) {
    if (config.permissions) {
      for (const permission of config.permissions) {
        items.push(permission)
      }
    }
  }
  return items
})
export const routes = computed(() => {
  const items: {
    [plugin: string]: { path: string; component: RawExtensionComponent }[]
  } = {}
  for (const [plugin, config] of Object.entries(registeredPlugins)) {
    if (config.routes) {
      items[plugin] = config.routes
    }
  }
  return items
})
export const menuItems = computed(() => {
  const items: MenuItem[] = []
  for (const [plugin, config] of Object.entries(registeredPlugins)) {
    console.log(`${plugin}: ${JSON.stringify(config)}`)
    if (config.menuItems) {
      for (const menu of config.menuItems) {
        if (!menu.path.includes(plugin)) {
          menu.path = `${plugin}/${menu.path}`
        }
        items.push(menu)
      }
    }
  }
  return items
})
export const disableWrapOnCallEnd: Ref<boolean> = ref(false)

export interface ExtensionConfig {
  settings?: RawExtensionComponent
  permissions?: { subject: string; action: string }[]
  routes?: { path: string; component: RawExtensionComponent }[]
  idleTabs?: Tab[]
  leadTabs?: Tab[]
  inboundTabs?: Tab[]
  menuItems?: MenuItem[]
}

export const LetsDialManager: LetsDialManagerType = {
  registerExtension(pluginName: string, config: ExtensionConfig) {
    registeredPlugins[pluginName] = config
    if (config.idleTabs) {
      config.idleTabs.forEach((tab) => {
        idleTabs.value.push(tab)
      })
    }
    if (config.leadTabs) {
      config.leadTabs.forEach((tab) => {
        leadTabs.value.push(tab)
      })
    }
    if (config.inboundTabs) {
      config.inboundTabs.forEach((tab) => {
        inboundTabs.value.push(tab)
      })
    }
  },
  idleView: {
    addTab(tab: Tab) {
      idleTabs.value.push(tab)
    },
  },
  menuItems: {
    addMenu(menu) {
      menuItems.value.push(menu)
    },
  },
  leadView: {
    addTab(tab: Tab) {
      leadTabs.value.push(tab)
    },
    disableWrapOnCallEnd() {
      // console.log('disableWrapOnCallEnd called')
      // disableWrapOnCallEnd.value = true
      // console.log(disableWrapOnCallEnd)
    },
  },
  inboundView: {
    addTab(tab: Tab) {
      inboundTabs.value.push(tab)
    },
  },
}
